import type { MonthNames } from 'dayjs';

export function capitalizeFirstLetter(monthText: MonthNames) {
  const monthStr = String(monthText);
  return monthStr.charAt(0).toUpperCase() + monthStr.slice(1);
}
